// src/components/AdminSettings/tabs/ChoresTab.tsx
import React from 'react';
import { add, trash } from 'ionicons/icons';
import { Button } from '../../ui/Button';
import { Card } from '../../ui/Card';
import { List, type ListItemProps } from '../../ui/List';
import { FREQUENCY_LABELS } from '../constants';
import type { ChoresTabProps } from '../types';

export const ChoresTab: React.FC<ChoresTabProps> = ({
  chores,
  onAddChore,
  onEditChore,
  onDeleteChore,
}) => {
  // Convert chores to List items
  const choreItems: ListItemProps[] = chores.map(chore => ({
    id: chore.id,
    label: chore.name,
    description: `⭐ ${chore.points_value} pts • ${FREQUENCY_LABELS[(chore as any).frequency] || 'Daily'}`,
    start: { element: <span style={{ fontSize: 24 }}>{chore.icon}</span> },
    end: {
      element: (
        <Button
          fill="clear"
          size="small"
          iconStart={trash}
          onClick={(e) => {
            e.stopPropagation();
            onDeleteChore(chore.id);
          }}
          aria-label="Delete task"
          style={{ color: 'var(--ion-color-danger)' }}
        />
      ),
    },
    onClick: () => onEditChore(chore),
  }));

  return (
    <>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 16,
      }}>
        <h3 style={{
          fontFamily: 'var(--kff-heading-font)',
          fontSize: 16,
          fontWeight: 600,
          margin: 0,
        }}>
          Task Templates
        </h3>
        <Button variant="primary" size="small" iconStart={add} onClick={onAddChore}>
          Add Task
        </Button>
      </div>

      {choreItems.length > 0 ? (
        <List items={choreItems} variant="default" size="md" lines="inset" />
      ) : (
        <Card style={{ textAlign: 'center' }}>
          <p style={{ color: 'var(--ion-color-medium)', marginBottom: 16 }}>
            No tasks defined yet
          </p>
          <Button variant="primary" onClick={onAddChore}>
            Add First Task
          </Button>
        </Card>
      )}
    </>
  );
};

export default ChoresTab;
